import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p>Due to the heat index exceeding 115 degrees, all outdoor operations have been suspended. Operations are able to resume outdoors once the heat index is below 115 degrees.</p>
     <ol>
        <li>Halt all outdoor operations</li>
        <li>Confirm all onsite personnel are inside the building</li>
        <li>Confirm all onsite personnel are accounted for</li>
        <li>Once above actions are confirmed, close out the exception</li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Suspend_Outdoor_Operations_High_Heat_Index.jsx